import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-slate-100 text-center">
      <h1 className="text-5xl font-bold text-slate-700 mb-4">404</h1>
      <p className="text-lg text-slate-500 mb-6">Oops! The page you're looking for does not exist.</p>
      <Link to="/" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Go Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
